import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const DevNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isDev = process.env.NODE_ENV === 'development';

  if (!isDev) return null;

  const isCRM = location.pathname.startsWith('/crm');
  const isPortal = location.pathname.startsWith('/portal');
  const isStart = location.pathname.startsWith('/start');

  const handleModeSwitch = (mode) => {
    if (mode === 'crm') {
      navigate('/crm');
    } else if (mode === 'portal') {
      navigate('/portal');
    } else if (mode === 'start') {
      navigate('/start');
    }
  };

  return (
    <>
      {/* Top Right - CRM/Portal/Start Navigation */}
      <div className="fixed top-0 right-0 z-50 bg-gray-800 dark:bg-gray-900 text-white px-4 py-2 rounded-bl-lg shadow-lg transition-colors duration-200">
        <div className="flex items-center space-x-2">
          <span className="text-sm font-medium mr-2">Dev Mode:</span>
          <button
            onClick={() => handleModeSwitch('crm')}
            className={`px-3 py-1 text-sm rounded transition-colors duration-200 ${
              isCRM 
                ? 'bg-blue-600 dark:bg-blue-500' 
                : 'bg-gray-600 hover:bg-blue-600 dark:bg-gray-500 dark:hover:bg-blue-500'
            }`}
          >
            CRM
          </button>
          <button
            onClick={() => handleModeSwitch('portal')}
            className={`px-3 py-1 text-sm rounded transition-colors duration-200 ${
              isPortal 
                ? 'bg-green-600 dark:bg-green-500' 
                : 'bg-gray-600 hover:bg-green-600 dark:bg-gray-500 dark:hover:bg-green-500'
            }`}
          >
            Portal
          </button>
          <button
            onClick={() => handleModeSwitch('start')}
            className={`px-3 py-1 text-sm rounded transition-colors duration-200 ${
              isStart 
                ? 'bg-purple-600 dark:bg-purple-500' 
                : 'bg-gray-600 hover:bg-purple-600 dark:bg-gray-500 dark:hover:bg-purple-500'
            }`}
          >
            Start
          </button>
        </div>
      </div>
    </>
  );
};

export default DevNavBar; 